import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  AvatarInput,
  Button,
  ButtonsWrapper,
  Form,
  PLATFORM_THEME_COLORS,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';

import { useEmployeeOwnDataUpdate } from 'src/hooks/employees/update-own-data.hook';
import { useChangeEmployeeAvatar } from 'src/hooks/employees/change-employee-avatar.hook';
import { PersonalInfo } from 'src/components/employee/personal-info';

const PersonalInfoEdit = ({
  onCancel,
  initialValues,
  isOwnData,
}: {
  onCancel: () => void;
  initialValues: any;
  isOwnData?: boolean;
}) => {
  const { t } = useTranslation(['employee', 'common']);
  const [avatar, setAvatar] = useState(initialValues?.profile?.avatarUrl);

  const memberOwnDataUpdate = useEmployeeOwnDataUpdate({ onSuccess: onCancel });
  const changeEmployeeAvatar = useChangeEmployeeAvatar();

  const onAvatarInputChange = (value: any) => {
    changeEmployeeAvatar({ variables: { memberId: initialValues._id, avatar: value } });
    setAvatar(value);
  };

  const onFinish = (values: any) => {
    const { emergencyContact } = values;
    memberOwnDataUpdate({
      variables: {
        payload: {
          address: values?.address,
          socials: values?.socials,
          ...(!isEmpty(emergencyContact) && { emergencyContact }),
        },
      },
    });
  };

  return (
    <div>
      <br />
      <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
        {t('employee:employeePersonalInfo.labels.personalInfo')}
      </Typography>
      <br />
      <AvatarInput size={64} avatar={avatar} squareCoverForm onChange={onAvatarInputChange} />
      <Form
        layout="vertical"
        onFinish={onFinish}
        initialValues={{
          ...initialValues,
          ...initialValues.profile,
          ...initialValues.account,
          employeePersonalInfo: {
            ...initialValues.employeePersonalInfo,
          },
          birthday: initialValues.profile?.birthday ? moment(initialValues.profile.birthday) : null,
        }}
      >
        <PersonalInfo isEdit isOwnData={isOwnData} employeeId={initialValues?._id} />
        <ButtonsWrapper>
          <Button type="primary" htmlType="submit">
            {t('common:buttons.save')}
          </Button>
          <Button onClick={onCancel}>{t('common:buttons.cancel')}</Button>
        </ButtonsWrapper>
      </Form>
    </div>
  );
};

export default PersonalInfoEdit;
